import React, { useRef, useState } from "react";
import {
  View,
  Modal,
  ScrollView,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
} from "react-native";

import Img from "component/img";
import Button from "component/button/Button";
import Text from "component/typography/Text";
import Icon from "component/typography/Icon";

import { colors, sizes } from "asset/constant";
import tinycolor from "tinycolor2";
import { useFlag } from "hook";
import { css } from "style";
import { sn } from "utils";

const imgSize = 60;

const originalImgSize: [number, number] = [588, 405];

export default function ProductImages(props: { images?: Array<string> }) {
  const list = useRef<ScrollView>(null);

  const { images } = props;
  const [currenIndex, setCurrentIndex] = useState(0);

  const _onNextSlide = () => {
    if (currenIndex + 1 === images.length) {
      return;
    }

    setCurrentIndex((prev) => {
      list?.current?.scrollTo({
        x: (prev + 1) * sizes.screenW,
        animated: true,
      });
      return prev + 1;
    });
  };

  const _onPrevSlide = () => {
    if (currenIndex === 0) {
      return;
    }

    setCurrentIndex((prev) => {
      list?.current?.scrollTo({
        x: (prev - 1) * sizes.screenW,
        animated: true,
      });
      return prev - 1;
    });
  };

  const {
    flg: fullScreen,
    on: showFullScreen,
    off: hideFullScreen,
  } = useFlag();

  return (
    <>
      <TouchableOpacity
        disabled={images?.length === 0}
        activeOpacity={sizes.tapOpacity}
        onPress={showFullScreen}
        style={{
          bottom: 0,
          aspectRatio: 0.69,
          overflow: "hidden",
          position: "absolute",
          ...css.shadowForWeb(10),
          width: sn(60, 60, 70, 75),
          right: sn(-7, -7, -9, -10),
          borderRadius: sizes.radius.xs,
        }}
      >
        <View
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: colors.bg.lightest,
          }}
        >
          <Icon type="entypo" name="yelp" size={50} />
        </View>
        <Img
          source={{ uri: images?.[0] }}
          style={{ width: "100%", height: "100%" }}
        />
      </TouchableOpacity>
      <Modal
        animationType="fade"
        visible={fullScreen}
        onRequestClose={hideFullScreen}
      >
        <SafeAreaView
          style={{ ...css.container, backgroundColor: colors.black }}
        >
          <ScrollView ref={list} pagingEnabled horizontal scrollEnabled={false}>
            {images?.map((uri, key) => {
              return (
                <Img
                  key={String(key)}
                  source={{ uri }}
                  style={styles.fullImg}
                />
              );
            })}
          </ScrollView>
        </SafeAreaView>

        <Button
          onPress={hideFullScreen}
          bgColor={tinycolor(colors.white).lighten(55).toString()}
          square={45}
          icon={{ name: "close", color: colors.danger }}
          absolute={{ top: sizes.space, left: sizes.space, zIndex: 1000 }}
        />

        {images?.length > 1 && (
          <View
            style={{
              width: "100%",
              position: "absolute",
              bottom: sizes.space,
              flexDirection: "row",
              paddingHorizontal: sizes.space,
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              onPress={_onPrevSlide}
              bgColor={tinycolor(colors.white).lighten(55).toString()}
              square={45}
              icon={{ name: "left", color: colors.theme, size: 18 }}
            />

            <Text color={colors.white} size={"lg"} weight="bold">
              {currenIndex + 1} / {images.length}
            </Text>
            <Button
              onPress={_onNextSlide}
              bgColor={tinycolor(colors.white).lighten(55).toString()}
              square={45}
              icon={{ name: "right", color: colors.theme, size: 18 }}
            />
          </View>
        )}
      </Modal>
    </>
  );
}

const styles = StyleSheet.create({
  fullImg: { width: sizes.screenW, height: "100%", resizeMode: "contain" },

  imgContainer: {
    width: imgSize,
    overflow: "hidden",
    borderRadius: sizes.radius.xs,
    height: imgSize * (originalImgSize[0] / originalImgSize[1]),
    ...css.shadowForWeb(5),
    bottom: 0,
    right: -7,
  },
});
